import { inject, signal, WritableSignal } from "@angular/core";
import { GetRowIdParams, GridApi, GridOptions } from "ag-grid-enterprise";

import { ClassificationTableSubscription, TableSource } from "./classification-table.subscription";
import { ChevronCellRenderer } from "@bitwarden/web-vault/app/components/tables/renderers/cell/end-icon-renderer/end-icon-renderer.component";
import { TableParent } from "@bitwarden/web-vault/app/models/types/table.types";
import { ClassificationView } from "@bitwarden/web-vault/app/models/view/classification/classification.view";
import { ClassificationItemRenderComponent } from "@bitwarden/web-vault/app/components/tables/renderers/cell/classification-item-renderer/classification-item-render.component";
import { I18nService } from "@bitwarden/common/abstractions/i18n.service";

export class ClassificationTable extends ClassificationTableSubscription {
  private i18nService = inject(I18nService);
  gridApi: GridApi;
  options: GridOptions<TableSource>;
  selectedClassification: WritableSignal<ClassificationView> = signal<ClassificationView>(null);

  constructor(parent: TableParent) {
    super();

    this.options = {
      context: { parent },
      rowSelection: "single",
      columnDefs: [
        {
          field: "name",
          cellRenderer: ClassificationItemRenderComponent,
          filter: "agTextColumnFilter",
          headerName: this.i18nService.t("classification"),
          flex: 3,
          minWidth: 150,
          cellStyle: { overflow: "visible", padding: "8px 0 8px 32px" },
        },
        {
          field: "rightChevron",
          cellRenderer: ChevronCellRenderer,
          // Only the name cell takes focus.
          suppressNavigable: true,
          flex: 0.3,
          maxWidth: 66,
          cellStyle: { overflow: "visible", padding: "8px 32px 8px 0" },
        },
      ],
      // The list is one Tab stop and the arrow keys move between rows (app-ag-grid-table's
      // tabToNextCell, #6246); Enter/Space run onRowClicked.
      suppressCellFocus: false,
      suppressContextMenu: true,
      onGridReady: (params) => {
        this.gridApi = params.api;
        this.onRowClicked(this.selectedClassification());
      },
      getRowId: (params: GetRowIdParams) => String(params.data.id),
      onRowClicked: (params) => {
        params.node.setSelected(true, false);
        this.onRowClicked(params.data);
      },
      getRowHeight: () => 88,
      getRowStyle: () => ({ overflow: "visible", background: "transparent", border: "none" }),
    };
  }

  onRowClicked(classification: ClassificationView): void {
    if (classification) {
      this.selectedClassification.set(classification);
    }
  }
}
